/**
 * Payment Required Context
 * 
 * Provides global state management for payment required modals.
 * Handles HTTP 402 (Payment Required) responses and modal visibility.
 */

import { createContext } from 'react';

/**
 * Payment Required Context
 */
export const PaymentRequiredContext = createContext({
  // Modal state
  isOpen: false,
  featureName: '',
  
  // Actions
  showPaymentRequired: () => {},
  hidePaymentRequired: () => {},
  
  // Error state
  error: null,
  setError: () => {}
});

/**
 * Default payment required state
 */
export const DEFAULT_PAYMENT_REQUIRED_STATE = {
  isOpen: false,
  featureName: '',
  error: null
};

/**
 * Payment Required Consumer
 * Higher-order component for consuming payment required context
 */
export const PaymentRequiredConsumer = PaymentRequiredContext.Consumer;
